import { getFeatureToggleClient } from '../../../infra/featureToggles'
import { computed, makeObservable } from 'mobx'
import { GetCurrentUserWorkspaceMemberships } from 'iam/WorkspaceMembershipStore'

/**
 * View model for scoping jobs.
 */
export default class OCRScopingJobsPermissionViewModel {
  constructor(
    private getCurrentUserWorkspaceMemberships: GetCurrentUserWorkspaceMemberships,
  ) {
    makeObservable(this)
  }

  /**
   * Feature toggle to show the scoping jobs page.
   */
  @computed
  get isScopingJobsPageEnabled() {
    return Boolean(
      getFeatureToggleClient().variation(
        'WorkPortal.ShowScopingJobsPage',
        false,
      ),
    )
  }

  @computed
  get canViewScopingJobs() {
    return Boolean(
      this.getCurrentUserWorkspaceMemberships().some(
        (wsm) =>
          wsm.member.hasPermission('SCOPE_WORK') &&
          wsm.member.hasPermission('ADMIN_SCOPE_WORK_VIEW'),
      ) && this.isScopingJobsPageEnabled,
    )
  }

  @computed
  get canManageOCRScopingJobs() {
    return this.getCurrentUserWorkspaceMemberships().some((wms) =>
      wms.member.hasPermission('ADMIN_MANAGE_OCR_JOBS'),
    )
  }
}
